export default function ChalkboardBackground({ 
  children, 
  className = '', 
  as: Component = 'div',
  backgroundImage,
  backgroundOpacity = 0.7,
  overlayColor = ''
}) {
  return (
    <Component className={`relative ${className}`} style={{ backgroundColor: '#1b1b1b' }}>
      {/* Base layer - solid color now */}
      <div className="absolute inset-0 bg-[#1b1b1b]" />
      
      {/* Custom background image if provided */}
      {backgroundImage && (
        <div 
          className="absolute inset-0 bg-cover bg-center z-0 pointer-events-none"
          style={{ 
            backgroundImage: `url(${backgroundImage})`,
            opacity: backgroundOpacity 
          }}
        />
      )}

      {/* Optional Overlay */}
      {overlayColor && (
        <div className={`absolute inset-0 z-10 pointer-events-none ${overlayColor}`} />
      )}
      
      {/* Content layer */}
      <div className="relative z-20">
        {children}
      </div>
    </Component>
  );
}
